import DialogTheme from "css/themes/dialogs/modalBase.css";
import { array, bool, func, node, object, oneOfType, string } from "prop-types";
import React, { Component } from "react";
import { Dialog } from "react-toolbox/lib/dialog";

class SimpleInfoModal extends Component {
  static propTypes = {
    active: bool.isRequired,
    close: func.isRequired,
    title: string.isRequired,
    children: oneOfType([array, node, object, func]).isRequired,
    className: string,
  };

  static defaultProps = {
    className: null,
  };

  render() {
    const { active, close, title, children, className } = this.props;

    return (
      <Dialog
        className={className}
        theme={DialogTheme}
        active={active}
        onEscKeyDown={close}
        onOverlayClick={close}
        title={title}
      >
        {children}
      </Dialog>
    );
  }
}

export default SimpleInfoModal;
